import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useFounderPlaces, SECTOR_TO_SPECIALITY } from "@/components/FoundersClub";
import { X } from "lucide-react";

const SECTOR_PATHS = { "/cqc": "cqc", "/ofsted": "ofsted", "/aesthetics": "aesthetics", "/gp-hospitals": "healthcare", "/fostering": "fostering" };
const HIDE_ON = ["/admin", "/login", "/register", "/reset-password", "/sign/", "/checkout"];

export default function FoundersCountdownBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const data = useFounderPlaces();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("founders-bar-dismissed") === "1");
  if (!data || dismissed || user?.founder || HIDE_ON.some((p) => pathname.startsWith(p))) return null;

  const speciality = user?.speciality || SECTOR_TO_SPECIALITY[SECTOR_PATHS[pathname]];
  const mine = speciality ? data.places.find((p) => p.speciality === speciality) : null;
  const open = data.places.filter((p) => p.left > 0);
  if (!open.length || (mine && mine.left <= 0)) return null;
  const fewest = open.reduce((a, b) => (a.left < b.left ? a : b));
  const place = mine || fewest;
  const text = (
    <>
      <span className="hidden sm:inline">Founders Club: </span><b>{place.taken} of {place.total}</b> places taken<span className="hidden md:inline"> in {place.label}</span> · <b>{place.left} left</b>
      <span className="hidden sm:inline"> · {data.percent_off}% off for as long as you stay fully subscribed</span><span className="sm:hidden"> · {data.percent_off}% off</span>
    </>
  );

  const dismiss = () => { sessionStorage.setItem("founders-bar-dismissed", "1"); setDismissed(true); };
  return (
    <div className="relative z-40 bg-founders-card text-white text-xs sm:text-sm border-b border-gold/30" data-testid="founders-countdown-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-3">
        <img src="/founders-club-logo.webp" alt="" className="w-6 h-6 rounded-full bg-white shrink-0" />
        <p className="flex-1 min-w-0 truncate" data-testid="founders-countdown-text">{text}</p>
        <Link to={user ? "/pricing" : "/register"} className="shrink-0 rounded-full bg-gold text-gold-foreground font-bold px-3 py-1 hover:bg-gold/90 transition-colors" data-testid="founders-countdown-cta">
          {user ? "See founder prices" : "Claim a place"}
        </Link>
        <button type="button" onClick={dismiss} aria-label="Dismiss" className="shrink-0 p-1 rounded hover:bg-white/10" data-testid="founders-countdown-dismiss"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
